export const membershipTypes = ["Wyndham"];
